<!-- Body Types Listing -->
<div class="card">
  <!-- Card Header -->
  <div class="card-header border-0 pt-6">
    <div class="card-title">
      <h3 class="fw-bold m-0">Body Types Management</h3>
    </div>
    <div class="card-toolbar">
      <!-- Base Toolbar -->
      <div class="d-flex justify-content-end" data-kt-body-type-table-toolbar="base">
        <!-- Filter Button -->
        <button type="button" class="btn btn-sm btn-light-primary me-3" (click)="toggleFilters()">
          <i class="ki-duotone ki-filter fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Filter
        </button>

        <!-- Add Body Type Button -->
        <button type="button" class="btn btn-sm btn-primary" (click)="openAddBodyTypeModal()">
          <i class="ki-duotone ki-plus fs-2"></i>
          Add Body Type
        </button>
      </div>

      <!-- Selected Toolbar -->
      <div class="d-flex justify-content-end align-items-center d-none" data-kt-body-type-table-toolbar="selected">
        <div class="fw-bold me-5">
          <span data-kt-body-type-table-select="selected_count"></span> Selected
        </div>
        <button type="button" class="btn btn-danger" (click)="bulkDelete()">
          Delete Selected
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Form -->
  <div *ngIf="showFiltersForm" [@slideInOut] class="card-body border-top">
    <div class="row g-3">
      <div class="col-md-4">
        <label class="form-label">Search</label>
        <input
          type="text"
          class="form-control form-control-solid"
          placeholder="Search body types..."
          [(ngModel)]="searchTerm"
        />
      </div>
      <div class="col-md-8 d-flex align-items-end">
        <button type="button" class="btn btn-sm btn-primary me-2" (click)="applyFilters()">
          <i class="ki-duotone ki-magnifier fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Search
        </button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="resetFilters()">
          <i class="ki-duotone ki-cross fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Reset
        </button>
      </div>
    </div>
  </div>

  <!-- Card Body -->
  <div class="card-body py-4">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="d-flex justify-content-center py-10">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && bodyTypes.length === 0" class="text-center py-10">
      <div class="mb-5">
        <i class="ki-duotone ki-file-deleted fs-5x text-muted">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <h5 class="text-muted">No body types found</h5>
      <p class="text-muted">Start by adding your first body type</p>
    </div>

    <!-- Data Table -->
    <div *ngIf="!isLoading && bodyTypes.length > 0" class="table-responsive">
      <table class="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
          <tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
            <th class="w-10px pe-2">
              <div class="form-check form-check-sm form-check-custom form-check-solid me-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="selectedBodyTypes.length === bodyTypes.length && bodyTypes.length > 0"
                  [indeterminate]="selectedBodyTypes.length > 0 && selectedBodyTypes.length < bodyTypes.length"
                  (change)="toggleAllSelection()"
                />
              </div>
            </th>
            <th class="min-w-125px">Name</th>
            <th class="min-w-125px">Type</th>
            <th class="text-end min-w-100px">Actions</th>
          </tr>
        </thead>
        <tbody class="text-gray-600 fw-semibold">
          <tr *ngFor="let bodyType of bodyTypes; trackBy: trackByFn">
            <td>
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [checked]="isSelected(bodyType._id || bodyType.id)"
                  (change)="toggleSelection(bodyType._id || bodyType.id)"
                />
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-start flex-column">
                  <span class="text-dark fw-bold text-hover-primary fs-6">{{ bodyType.name }}</span>
                </div>
              </div>
            </td>
            <td>
              <span class="badge badge-light-info">{{ bodyType.type?.name || 'N/A' }}</span>
            </td>
            <td class="text-end">
              <div class="d-flex justify-content-end">
                <!-- Edit Button -->
                <button
                  type="button"
                  class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                  (click)="openEditModal(bodyType)"
                  title="Edit"
                >
                  <i class="ki-duotone ki-pencil fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </button>

                <!-- Delete Button -->
                <button
                  type="button"
                  class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                  (click)="deleteBodyType(bodyType)"
                  title="Delete"
                >
                  <i class="ki-duotone ki-trash fs-2">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                    <span class="path5"></span>
                  </i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="!isLoading && bodyTypes.length > 0">
      <app-pagination
        [paginationInfo]="paginationInfo"
        [loading]="isLoading"
        (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Body Type Add/Edit Modal -->
<app-add-edit-body-type
  (bodyTypeAdded)="onBodyTypeAdded()"
  (bodyTypeUpdated)="onBodyTypeUpdated()">
</app-add-edit-body-type>
